export const cpSheetDailyAnalyticsBiGraphConfig = (dataPoints = []) => {
  return {
    data: dataPoints || [],
    xField: "date",
    yField: "value",
    stack: true,
    colorField: "type",
    label: {
      text: "value",
      textBaseline: "bottom",
      position: "inside"
    },
    interaction: {
      elementHighlightByColor: {
        link: true
      }
    },
    state: {
      active: { linkFill: "rgba(0,0,0,0.25)", stroke: "black", lineWidth: 0.5 },
      inactive: { opacity: 0.5 }
    }
  };
};
